export default {"src":"/_next/static/media/markdown.58d59da0.svg","height":158,"width":256,"blurWidth":0,"blurHeight":0};